"use client"

import { useCallback } from "react"

export function useHaptic() {
  const triggerHaptic = useCallback((type: "light" | "medium" | "heavy" | "success" | "error" = "light") => {
    // Sadece tarayıcı ve titreşim API'si destekleniyorsa çalıştır
    if (typeof window === "undefined" || !window.navigator || !window.navigator.vibrate) {
      return
    }

    try {
      switch (type) {
        case "light":
          window.navigator.vibrate(10)
          break
        case "medium":
          window.navigator.vibrate(20)
          break
        case "heavy":
          window.navigator.vibrate(30)
          break
        case "success":
          window.navigator.vibrate([10, 50, 20])
          break
        case "error":
          window.navigator.vibrate([30, 40, 30, 40, 40])
          break
        default:
          window.navigator.vibrate(15)
      }
    } catch {
      // Haptic hatası önemli değil, sessizce geç
    }
  }, [])

  return triggerHaptic
}
